import './SingleSelectFilterFormWithPairs.css';
import * as React from 'react';
import { t } from 'i18next';
import Loading from '../../../loading/Loading';
import { isEmptyObject } from '../../../../helpers/utils';

const SingleSelectFilterFormWithPairs = (label, fetchPossibleValues, defaultKey = '') => class extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      possibleValues: fetchPossibleValues
    };
  }

  render() {
    const { updateCurrent, current } = this.props;
    const { possibleValues } = this.state;
    return (
      <div className="SingleSelectFilterForm">
        {isEmptyObject(possibleValues) ? <Loading size={40} /> : (
          <select defaultValue={current}
            onChange={(e) => { updateCurrent(e.target.value); }}
          >
            <option default
              value={defaultKey}
            >
              {t(`filters.placeholder.${label}`)}
            </option>
            {Object.keys(possibleValues)
              .map(key => (
                <option key={key}
                  value={key}
                >
                  {possibleValues[key]}
                </option>
              ))}
          </select>
        )}
      </div>
    );
  }
};

export default SingleSelectFilterFormWithPairs;
